module.exports = __webpack_public_path__ + "img/bg-section-02.997654f3.svg";